// import React, { useEffect, useRef, useState } from "react";
// import KibabMenu from "../../../../../assets/icons/kibab-menu";
// import { useDispatch } from "react-redux";
// import {
//   deleteTaxCombinationAction,
//   taxCombinationListAction,
// } from "../../../../../redux/actions/settings-action";
// import EditIcon from "../../../../../assets/icons/editIconPencil.svg";
// import TaxCombination from "./tax-combination-view";
// import DeleteIcon from "../../../../../assets/icons/delete-icon";
// import successToast from "../../../../helper-components/success-toast";
// import errorToast from "../../../../helper-components/error-toast";
// import LoadingSpinner from "../../../../helper-components/loading-spinner";

// const TaxCombinationTable = ({ searchValue, reload }) => {
//   const tableHeading = ["Code", "Rate %", "Combination", "Effective From", ""];
//   const [selectedDOtIndex, setSelectedDOtIndex] = useState(null);
//   const [initialData, setTaxCombinationData] = useState([]);
//   const [showAddEdit, setShowAddEdit] = useState(false);
//   const [isView, setIsView] = useState(false);
//   const [editingData, setEditingData] = useState({});
//   const [loading, setLoading] = useState(false);

//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(taxCombinationListAction({}, onFetchSuccess, onFetchError));
//     setLoading(true);
//   }, []);

//   useEffect(() => {
//     dispatch(
//       taxCombinationListAction({ searchValue }, onFetchSuccess, onFetchError)
//     );
//     setLoading(true);
//   }, [searchValue, reload]);

//   const reloadData = () => {
//     dispatch(taxCombinationListAction({}, onFetchSuccess, onFetchError));
//     setLoading(true);
//   };

//   const onFetchSuccess = (data) => {
//     setTaxCombinationData(data?.data?.taxCombinationList);
//     setLoading(false);
//   };

//   const onFetchError = (data) => {
//     setLoading(false);
//     errorToast(data?.message);
//     setTaxCombinationData([]);
//   };

//   const onCLickEdit = (data) => {
//     setEditingData(data);
//     setShowAddEdit(true);
//     setSelectedDOtIndex(null);
//   };

//   const onClickDelete = (id) => {
//     dispatch(deleteTaxCombinationAction({ id }, onDeletSuccess, onError));
//   };
//   const onDeletSuccess = (data) => {
//     reloadData();
//     successToast(data?.message);
//     setSelectedDOtIndex(null);
//   };

//   const onError = (data) => {
//     errorToast(data?.message);
//   };

//   const onCLickTr = (data) => {
//     setEditingData(data);
//     setShowAddEdit(true);
//     setIsView(true);
//   };
//   const componentRef = useRef(null);

//   const handleClickOutside = (event) => {
//     if (componentRef.current && !componentRef.current.contains(event.target)) {
//       setSelectedDOtIndex(null);
//     }
//   };

//   const toogleChange = () => {
//     setShowAddEdit(!showAddEdit);
//   };

//   return (
//     <div>
//       <div
//         onClick={handleClickOutside}
//         className="flex flex-col justify-between"
//         style={{ height: "80vh" }}
//       >
//         {loading ? (
//           <LoadingSpinner />
//         ) : !showAddEdit ? (
//           <>
//             <div className="overflow-auto mb-auto rounded-xl table-container border border-gray-200">
//               <table className=" w-full ">
//                 <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
//                   <tr className="relative h-[50px]">
//                     {tableHeading.map((heading, index) => (
//                       <th
//                         className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
//                         key={heading}
//                       >
//                         {heading}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody style={{ position: "relative" }}>
//                   {initialData?.map((item, index) => (
//                     <tr key={index}>
//                       <td
//                         className={`tab-cell text-sm fw_400 text-secondary`}
//                         onClick={() => onCLickTr(item)}
//                       >
//                         {item?.code}
//                       </td>
//                       <td
//                         className={`tab-cell text-sm fw_400 text-secondary`}
//                         onClick={() => onCLickTr(item)}
//                       >
//                         {item?.rate}
//                       </td>
//                       <td
//                         className={`tab-cell text-sm fw_400 text-secondary`}
//                         onClick={() => onCLickTr(item)}
//                       >
//                         {item?.tax_combination_items
//                           ?.map((taxComb) => taxComb?.tax_type?.name)
//                           .join(" + ")}
//                       </td>
//                       <td
//                         className={`tab-cell text-sm fw_400 text-secondary`}
//                         onClick={() => onCLickTr(item)}
//                       >
//                         {item.effective_from}
//                       </td>
//                       <td className="tab-cell w-[5rem] text-sm fw_400 text-secondary p-8">
//                         <button onClick={() => setSelectedDOtIndex(index)}>
//                           <KibabMenu />
//                         </button>
//                         {selectedDOtIndex === index && (
//                           <div
//                             ref={componentRef}
//                             style={{
//                               position: "absolute",
//                               right: "2rem",
//                               boxShadow:
//                                 "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
//                             }}
//                             className="bg-white rounded w-52"
//                           >
//                             <div className="w-full p-4">
//                               <button
//                                 className="w-full flex align-middle gap-2 px-2 py-2"
//                                 onClick={() => onCLickEdit(item)}
//                               >
//                                 <img alt="editIcon" src={EditIcon} />
//                                 <span className="text-sm">Edit</span>
//                               </button>
//                               <button
//                                 className="w-full flex align-middle gap-2 px-2 py-1"
//                                 onClick={() => onClickDelete(item?.id)}
//                               >
//                                 <div className="mt-1">
//                                   <DeleteIcon />
//                                 </div>
//                                 <span className="text-sm">Delete</span>
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </>
//         ) : (
//           <TaxCombination
//             editingData={editingData}
//             isView={isView}
//             reloadData={reloadData}
//             toogleChange={toogleChange}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default TaxCombinationTable;

import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import KibabMenu from "../../../../../assets/icons/kibab-menu";
import { useDispatch } from "react-redux";
import {
  deleteTaxCombinationAction,
  taxCombinationListAction,
} from "../../../../../redux/actions/settings-action";
import EditIcon from "../../../../../assets/icons/editIconPencil.svg";
import TaxCombination from "./tax-combination-view";
import DeleteIcon from "../../../../../assets/icons/delete-icon";
import successToast from "../../../../helper-components/success-toast";
import errorToast from "../../../../helper-components/error-toast";
import LoadingSpinner from "../../../../helper-components/loading-spinner";

const TaxCombinationTable = ({ searchValue, reload }) => {
  const tableHeading = ["Code", "Rate %", "Combination","GST Type", "Effective From", "Actions"];
  const [selectedDOtIndex, setSelectedDOtIndex] = useState(null);
  const [initialData, setTaxCombinationData] = useState([]);
  const [showAddEdit, setShowAddEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [editingData, setEditingData] = useState({});
  const [loading, setLoading] = useState(false);
  const [dropdownCoords, setDropdownCoords] = useState({ top: 0, left: 0 });

  const dispatch = useDispatch();
  const componentRef = useRef(null);

  useEffect(() => {
    dispatch(taxCombinationListAction({}, onFetchSuccess, onFetchError));
    setLoading(true);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(
      taxCombinationListAction({ searchValue }, onFetchSuccess, onFetchError)
    );
    setLoading(true);
    // eslint-disable-next-line
  }, [searchValue, reload]);

  const reloadData = () => {
    dispatch(taxCombinationListAction({}, onFetchSuccess, onFetchError));
    setLoading(true);
  };

  const onFetchSuccess = (data) => {
    setTaxCombinationData(data?.data?.taxCombinationList);
    setLoading(false);
  };

  const onFetchError = (data) => {
    setLoading(false);
    errorToast(data?.message);
    setTaxCombinationData([]);
  };

  const onCLickEdit = (data) => {
    setEditingData(data);
    setShowAddEdit(true);
    setSelectedDOtIndex(null);
  };

  const onClickDelete = (id) => {
    dispatch(deleteTaxCombinationAction({ id }, onDeletSuccess, onError));
  };
  const onDeletSuccess = (data) => {
    reloadData();
    successToast(data?.message);
    setSelectedDOtIndex(null);
  };
  const onError = (data) => {
    errorToast(data?.data?.message);
  };

  const onCLickTr = (data) => {
    setEditingData(data);
    setShowAddEdit(true);
    setIsView(true);
  };

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        selectedDOtIndex !== null &&
        componentRef.current &&
        !componentRef.current.contains(event.target)
      ) {
        setSelectedDOtIndex(null);
      }
    }
    if (selectedDOtIndex !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectedDOtIndex]);

  const toogleChange = () => {
    setShowAddEdit(!showAddEdit);
  };

  // Menu portal
  const renderMenuPortal = () => {
    if (selectedDOtIndex !== null && initialData[selectedDOtIndex]) {
      const menu = (
        <div
          ref={componentRef}
          style={{
            position: "fixed",
            top: dropdownCoords.top,
            left: dropdownCoords.left,
            zIndex: 10000,
            background: "white",
            borderRadius: "8px",
            width: "13rem",
            boxShadow: "rgba(99,99,99,0.2) 0px 2px 8px 0px",
          }}
        >
          <div className="w-full p-4">
            <button
              className="w-full flex align-middle gap-2 px-2 py-2"
              onClick={() => {onCLickEdit(initialData[selectedDOtIndex]);}}
            >
              <img alt="editIcon" src={EditIcon} />
              <span className="text-sm">Edit</span>
            </button>
            <button
              className="w-full flex align-middle gap-2 px-2 py-1"
              onClick={() => onClickDelete(initialData[selectedDOtIndex]?.id)}
            >
              <div className="mt-1">
                <DeleteIcon />
              </div>
              <span className="text-sm">Delete</span>
            </button>
          </div>
        </div>
      );
      return ReactDOM.createPortal(menu, document.body);
    }
    return null;
  };

  return (
    <div>
      <div className="flex flex-col justify-between" style={{ height: "80vh" }}>
        {loading ? (
          <LoadingSpinner />
        ) : !showAddEdit ? (
          <>
            <div className="overflow-auto mb-auto rounded-xl table-container border border-gray-200">
              <table className="w-full">
                <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                  <tr className="relative h-[50px]">
                    {tableHeading.map((heading, index) => (
                      <th
                        className="text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]"
                        key={heading}
                      >
                        {heading?.toUpperCase()}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody style={{ position: "relative" }}>
                  {initialData?.map((item, index) => (
                    <tr key={index}>
                      <td
                        className="tab-cell text-sm fw_400 text-secondary"
                        onClick={() => onCLickTr(item)}
                      >
                        {item?.code}
                      </td>
                      <td
                        className="tab-cell text-sm fw_400 text-secondary"
                        onClick={() => onCLickTr(item)}
                      >
                        {item?.rate}
                      </td>
                      <td
                        className="tab-cell text-sm fw_400 text-secondary"
                        onClick={() => onCLickTr(item)}
                      >
                        {item?.tax_combination_items
                          ?.map((taxComb) => taxComb?.tax_type?.name)
                          .join(" + ")}
                      </td>
                      <td
                        className="tab-cell text-sm fw_400 text-secondary"
                        onClick={() => onCLickTr(item)}
                      >
                        {item?.is_inter_state === true
                          ? "Inter"
                          : item?.is_inter_state === false
                            ? "Intra"
                            : "-"}

                      </td>
                      <td
                        className="tab-cell text-sm fw_400 text-secondary"
                        onClick={() => onCLickTr(item)}
                      >
                        {item.effective_from}
                      </td>
                      <td
                        className="tab-cell w-[5rem] text-sm fw_400 text-secondary p-8"
                        style={{ position: "relative" }}
                      >
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedDOtIndex(index);
                            const rect =
                              e.currentTarget.getBoundingClientRect();
                            setDropdownCoords({
                              top: rect.bottom + window.scrollY,
                              left: rect.left + window.scrollX - 140,
                            });
                          }}
                        >
                          <KibabMenu />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* Portal serves entire page, so render only outside table */}
              {renderMenuPortal()}
            </div>
          </>
        ) : (
          <TaxCombination
            editingData={editingData}
            isView={isView}
            reloadData={reloadData}
            toogleChange={toogleChange}
          />
        )}
      </div>
    </div>
  );
};

export default TaxCombinationTable;
